<template>
  <div class="reports pb-9">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text class="pt-3"> </v-card-text>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q</v-btn
          >
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2">نمودار فروش</h4>
      </div>
      <hr class="mt-5" />
      <v-card v-if="loading" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#6200ea'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <v-row>
            <v-col class="d-flex flex-column flex-md-row">
              <div>
                <h4 class="primary--text">نمودار فروش فروشگاه</h4>
              </div>
              <div
                class="d-flex flex-row flex-wrap ms-0 mt-4 mt-md-0 ms-md-15"
                style="transform: translateY(-4px)"
              >
                <div class="me-0 me-md-10 mt-2 c-grey">مشاهده:</div>
                <div
                  v-for="(item, index) in sortOptions"
                  :key="index"
                  class="sort-box me-1 pointer"
                  @click="selectedSort = item"
                  :class="selectedSort == item ? 'selected-sort' : ''"
                >
                  {{ item }}
                </div>
              </div>
            </v-col>
          </v-row>

          <div v-if="selectedSort == '30 روزه'">
            <div class="report-time mt-8 pointer" id="monthDate">
              <div>
                <span class="c-grey">{{ persianMonthName(monthDate) }}</span>
                <v-icon class="ms-6">$Calendar</v-icon>
              </div>
            </div>
            <date-picker
              element="monthDate"
              v-model="monthDate"
              type="year-month"
              color="#4ba0e7"
              @change="getMonthData"
            ></date-picker>
            <div class="mt-5">
              <Chart
                name="barChart"
                type="bar"
                :chartdata="monthChart"
                :options="optionsBar"
                height="160"
                class="d-none d-md-block"
                v-if="!loading"
              >
              </Chart>
              <Chart
                name="barChartRes"
                type="bar"
                :chartdata="monthChart"
                :options="optionsBar"
                height="460"
                class="d-block d-md-none"
                v-if="!loading"
              >
              </Chart>
            </div>
            <div
              class="mt-15 py-5 d-flex flex-row flex-wrap justify-content-start justify-md-center"
            >
              <div class="blue-box">
                <div class="d-flex">
                  <div class="blue-iconBox"><v-icon>$Wallet</v-icon></div>
                  <div class="pa-2">هزینه‌های ناخالص فروش</div>
                </div>
                <div class="price mt-2">
                  {{ monthData.totalExpense }} میلیون تومان
                </div>
              </div>
              <div class="purple-box">
                <div class="d-flex">
                  <div class="orange-iconBox"><v-icon>$Wallet</v-icon></div>
                  <div class="pa-2">مبلغ دریافتی از فروش</div>
                </div>
                <div class="price mt-2">
                  {{ monthData.totalIncome }} میلیون تومان
                </div>
              </div>
              <div
                :class="monthData.totalProfit >= 0 ? 'green-box' : 'red-box'"
              >
                <div class="d-flex">
                  <div
                    :class="
                      monthData.totalProfit >= 0
                        ? 'green-iconBox'
                        : 'red-iconBox'
                    "
                  >
                    <v-icon v-if="monthData.totalProfit >= 0">$TrendUp</v-icon>
                    <v-icon v-else>$TrendDown</v-icon>
                  </div>
                  <div class="pa-2">
                    {{
                      monthData.totalProfit >= 0
                        ? "میزان سود ناخالص"
                        : "میزان ضرر ناخالص"
                    }}
                  </div>
                </div>
                <div class="price mt-2">
                  {{ Math.abs(monthData.totalProfit) }} میلیون تومان
                </div>
              </div>
            </div>
   <div
              class="mt-15 py-5 d-flex flex-row flex-wrap justify-content-start justify-md-center"
            >
              <div class="blue-box">
                <div class="d-flex">
                  <div class="blue-iconBox"><v-icon>$Wallet</v-icon></div>
                  <div class="pa-2">سایر درآمد‌ها</div>
                </div>
                <div class="price mt-2">
                  {{ monthData.otherIncome }} میلیون تومان
                </div>
              </div>
              <div class="purple-box">
                <div class="d-flex">
                  <div class="orange-iconBox"><v-icon>$Wallet</v-icon></div>
                  <div class="pa-2">سایر هزینه‌ها </div>
                </div>
                <div class="price mt-2">
                  {{ monthData.otherExpense }} میلیون تومان
                </div>
              </div>
              <div
                :class="monthData.netProfit >= 0 ? 'green-box' : 'red-box'"
              >
                <div class="d-flex">
                  <div
                    :class="
                      monthData.netProfit >= 0
                        ? 'green-iconBox'
                        : 'red-iconBox'
                    "
                  >
                    <v-icon v-if="monthData.netProfit >= 0">$TrendUp</v-icon>
                    <v-icon v-else>$TrendDown</v-icon>
                  </div>
                  <div class="pa-2">
                    {{
                      monthData.netProfit >= 0
                        ? "میزان سود خالص"
                        : "میزان ضرر خالص"
                    }}
                  </div>
                </div>
                <div class="price mt-2">
                  {{ Math.abs(monthData.netProfit) }} میلیون تومان
                </div>
              </div>
            </div>


          </div>
          <div class="mt-8" style="letter-spacing: 1px" v-else>
            <div id="weekDate" class="pointer report-time d-flex pe-3">
              <span class="px-2 grey--text text--darken-2">{{
                computedFilterDate
              }}</span>
              <div>
                <v-icon class="c-blue ps-2">$Calendar</v-icon>
              </div>
            </div>
            <date-picker
              element="weekDate"
              v-model="startDate"
              type="date"
              color="#4ba0e7"
              @change="getReport()"
            ></date-picker>
            <div class="mt-5">
              <Chart
                name="barChart"
                type="bar"
                :chartdata="weekChart"
                :options="optionsBar"
                height="160"
                class="d-none d-md-block"
                v-if="!loading"
              >
              </Chart>
              <Chart
                name="barChartRes"
                type="bar"
                :chartdata="weekChart"
                :options="optionsBar"
                height="460"
                class="d-block d-md-none"
                v-if="!loading"
              >
              </Chart>
            </div>
            <div
              class="mt-15 py-5 d-flex flex-row flex-wrap justify-content-start justify-content-md-center"
            >
              <div class="blue-box">
                <div class="d-flex">
                  <div class="blue-iconBox"><v-icon>$Wallet</v-icon></div>
                  <div class="pa-2">هزینه‌های ناخالص فروش</div>
                </div>
                <div class="price mt-2">
                  {{ weekData.totalExpense }} میلیون تومان
                </div>
              </div>
              <div class="purple-box">
                <div class="d-flex">
                  <div class="orange-iconBox"><v-icon>$Wallet</v-icon></div>
                  <div class="pa-2">مبلغ دریافتی از فروش</div>
                </div>
                <div class="price mt-2">
                  {{ weekData.totalIncome }} میلیون تومان
                </div>
              </div>
              <div :class="weekData.totalProfit >= 0 ? 'green-box' : 'red-box'">
                <div class="d-flex">
                  <div
                    :class="
                      weekData.totalProfit >= 0
                        ? 'green-iconBox'
                        : 'red-iconBox'
                    "
                  >
                    <v-icon v-if="weekData.totalProfit >= 0">$TrendUp</v-icon>
                    <v-icon v-else>$TrendDown</v-icon>
                  </div>
                  <div class="pa-2">
                    {{
                      weekData.totalProfit >= 0
                        ? "میزان سود ناخالص"
                        : "میزان ضرر ناخالص"
                    }}
                  </div>
                </div>
                <div class="price mt-2">
                  {{ Math.abs(weekData.totalProfit) }} میلیون تومان
                </div>
              </div>
            </div>


             <div
              class="mt-15 py-5 d-flex flex-row flex-wrap justify-content-start justify-content-md-center"
            >
              <div class="blue-box">
                <div class="d-flex">
                  <div class="blue-iconBox"><v-icon>$Wallet</v-icon></div>
                  <div class="pa-2">  سایر درآمد‌ها</div>
                </div>
                <div class="price mt-2">
                  {{ weekData.otherIncome }} میلیون تومان
                </div>
              </div>
              <div class="purple-box">
                <div class="d-flex">
                  <div class="orange-iconBox"><v-icon>$Wallet</v-icon></div>
                  <div class="pa-2">سایر هزینه‌ها</div>
                </div>
                <div class="price mt-2">
                  {{ weekData.otherExpense}} میلیون تومان
                </div>
              </div>
              <div :class="weekData.netProfit  >= 0 ? 'green-box' : 'red-box'">
                <div class="d-flex">
                  <div
                    :class="
                      weekData.netProfit  >= 0
                        ? 'green-iconBox'
                        : 'red-iconBox'
                    "
                  >
                    <v-icon v-if="weekData.netProfit  >= 0">$TrendUp</v-icon>
                    <v-icon v-else>$TrendDown</v-icon>
                  </div>
                  <div class="pa-2">
                    {{
                      weekData.netProfit  >= 0
                        ? "میزان سود خالص"
                        : "میزان ضرر خالص"
                    }}
                  </div>
                </div>
                <div class="price mt-2">
                  {{ Math.abs(weekData.netProfit)  }} میلیون تومان
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import { AtomSpinner } from "epic-spinners";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import MyCalendar from "../../components/MyCalendar.vue";
import Chart from "../../components/charts/Chart.vue";

export default {
  components: {
    Chart,
    MyCalendar,
    AtomSpinner,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      moment: moment,
      guide: false,
      monthsName: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      sortOptions: ["7 روزه", "30 روزه"],
      selectedSort: "7 روزه",
      monthDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      startDate: moment(new Date()).subtract(6, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      loading: false,
      optionsBar: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            rtl: true,
            display: false,
            position: "top",
            labels: {
              font: {
                family: "iranyekan",
              },
              boxWidth: 25,
              boxHeight: 8,
            },
          },
          tooltip: {
            titleFont: {
              family: "iranyekan",
            },
            bodyFont: {
              family: "iranyekan",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            min: 0,
            title: {
              display: true,
              text: "میزان درآمد (میلیون  تومان)",
              font: { family: "iranyekan" },
            },
            grid: {
              display: false,
            },
            ticks: {
              label: "میزان درآمد (میلیون  تومان)",
              stepSize: 1,
              beginAtZero: true,
              font: { family: "iranyekan" },
            },
            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              font: {
                family: "iranyekan",
              },
            },
          },
        },
      },
      weekChart: {},
      weekData: {},
      monthChart: {},
      monthData: {},
      monthsName: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      deviceType: "",
    };
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    persianMonthName(month) {
      let date;
      date =
        this.monthsName[Number(month.split("/")[1]) - 1] +
        "  " +
        month.split("/")[0];
      return date;
    },
    getStartDate(value) {
      this.startDate = value;
    },
    getEndDate(value) {
      this.endDate = value;
    },
    getweekData() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/reports/weekly",
        {
          startDate: this.startDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.weekData = res.data;
            this.weekChart = res.data.weeklyIncome;
            if (window.screen.width < 950) {
              this.deviceType = "mobile";
              this.weekChart.datasets[0].backgroundColor = "#4BA0E7";
              this.weekChart.datasets[0].borderRadius = 5;
              this.weekChart.datasets[0].barPercentage = 0.5;
              this.weekChart.datasets[0].barThickness = 10;
            } else {
              if (document.body.clientWidth < 950) {
                this.deviceType = "mobile";
                this.weekChart.datasets[0].backgroundColor = "#4BA0E7";
                this.weekChart.datasets[0].borderRadius = 10;
                this.weekChart.datasets[0].barPercentage = 0.5;
                this.weekChart.datasets[0].barThickness = 10;
              } else {
                this.deviceType = "desktop";
                this.weekChart.datasets[0].backgroundColor = "#4BA0E7";
                this.weekChart.datasets[0].borderRadius = 10;
                this.weekChart.datasets[0].barPercentage = 0.5;
                this.weekChart.datasets[0].barThickness = 60;
              }
            }
            setTimeout(() => {
              this.loading = false;
            }, 200);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getReport() {
      this.endDate = moment(this.startDate, "jYYYY/jMM/jDD")
        .add(6, "days")
        .format("jYYYY/jMM/jDD");
      this.getweekData();
    },
    getMonthData() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/reports/monthly",
        {
          year: this.monthDate.split("/")[0],
          month: parseInt(this.monthDate.split("/")[1]),
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.monthData = res.data;
            this.monthChart = res.data.monthlyIncome;
            if (window.screen.width < 950) {
              this.deviceType = "mobile";
              this.monthChart.datasets[0].borderRadius = 3;
              this.monthChart.datasets[0].barPercentage = 0.5;
              this.monthChart.datasets[0].barThickness = 3;
            } else {
              if (document.body.clientWidth < 950) {
                this.deviceType = "mobile";
                this.monthChart.datasets[0].borderRadius = 5;
                this.monthChart.datasets[0].barPercentage = 0.5;
                this.monthChart.datasets[0].barThickness = 10;
              } else {
                this.deviceType = "desktop";
                this.monthChart.datasets[0].borderRadius = 10;
                this.monthChart.datasets[0].barPercentage = 0.5;
                this.monthChart.datasets[0].barThickness = 10;
              }
            }
            this.monthChart.datasets[0].backgroundColor = "#4BA0E7";
            setTimeout(() => {
              this.loading = false;
            }, 200);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    persianMonthName2(month) {
      let monthName;
      monthName = this.monthsName[Number(month) - 1];
      return monthName;
    },
  },
  computed: {
    computedFilterDate() {
      if (this.startDate && this.endDate) {
        let date =
          "از تاریخ " +
          this.startDate.split("/")[2] +
          "/" +
          this.persianMonthName2(this.startDate.split("/")[1]) +
          "/" +
          this.startDate.split("/")[0] +
          " تا تاریخ " +
          this.endDate.split("/")[2] +
          "/" +
          this.persianMonthName2(this.endDate.split("/")[1]) +
          "/" +
          this.endDate.split("/")[0];

        return date;
      }
    },
  },
  mounted() {
    this.getweekData();
    this.getMonthData();
  },
};
</script>

<style lang="scss">
.reports {
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    color: #656a81;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;
      &:hover {
        background-color: #00b4d8;
      }
    }
    &:hover {
      background-color: #eee;
    }
  }
  .orange-borderedBtn {
    background-color: #f4f4ff !important;
  }

  // boxes
  @mixin reportBox($color) {
    padding: 15px;
    color: #616161;
    font-size: 1.05rem;
    border-right: 4px solid $color;
    letter-spacing: 0;
    .price {
      color: $color;
      font-size: 1.08rem;
    }
  }
  .blue-box {
    @include reportBox(#4ba0e7);
  }
  .purple-box {
    @include reportBox(#6200ea);
  }
  .green-box {
    @include reportBox(#12b8a1);
  }
  .red-box {
    @include reportBox(#f3536e);
  }
}

.product-dialog-card {
  border-radius: 15px !important;
  padding: 10px;
  max-height: 680px;
  overflow-y: auto;
  .custom-input {
    .v-textarea {
      .v-input__slot {
        height: 246px !important;
      }
    }
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #6200ea !important;
        cursor: pointer;
      }
    }
  }
}
.report-time {
  border: 1px solid #4ba0e7;
  border-radius: 8px;
  padding: 9px 15px;
  width: fit-content;
  span {
    letter-spacing: 1px;
    padding-top: 3px;
  }
  .v-icon {
    margin-top: -2px;
  }
  &:hover {
    background-color: #7534d60f;
  }
}
</style>
